const timeline = [
  { label: 'Booking Confirmed', time: 'Apr 12', status: 'done', msg: '✈️ Your Bali trip is confirmed! See you soon.' },
  { label: '48h Pre-Trip Reminder', time: 'Apr 10', status: 'done', msg: '🧳 Trip in 2 days! Here\'s your itinerary & hotel details.' },
  { label: 'Mid-Trip Check-in', time: 'Apr 15', status: 'active', msg: '😊 How\'s the trip so far? Need anything?' },
  { label: 'Post-Trip Feedback', time: 'Apr 20', status: 'pending', msg: '⭐ We\'d love your feedback! 2 min survey.' },
];

export default function FollowupCRMModule() {
  return (
    <section id="followup" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                <i className="ri-refresh-line text-teal-500" />
              </div>
              <span className="text-xs font-semibold uppercase tracking-widest text-teal-600">Module 07</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight mb-4">
              WhatsApp Follow-ups &<br />
              <span className="bg-gradient-to-r from-teal-500 to-emerald-500 bg-clip-text text-transparent">Full CRM History</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              The relationship doesn't end at booking. TreWaz's WhatsApp chatbot follows up pre-trip, mid-trip, and post-trip — collecting feedback, handling modification requests, and processing cancellations. Every message stays in one CRM timeline.
            </p>
            <ul className="flex flex-col gap-4">
              {[
                { icon: 'ri-history-line', title: 'Complete conversation history', desc: 'Every WhatsApp message, quote sent, and booking update is stored chronologically in the customer\'s CRM profile.' },
                { icon: 'ri-timer-2-line', title: 'Automated follow-up sequences', desc: 'Pre-trip reminders, day-of messages, post-trip check-ins — all sent automatically at the right time. Zero manual work.' },
                { icon: 'ri-star-line', title: 'Feedback collection', desc: 'Post-trip, the chatbot asks for a review and rating. Responses are logged in the CRM for your records.' },
                { icon: 'ri-loop-left-line', title: 'Modification & cancellation handling', desc: 'Customer wants to change dates or cancel? The chatbot captures the request and routes it to the right agent instantly.' },
              ].map((item) => (
                <li key={item.title} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg shrink-0 mt-0.5">
                    <i className={`${item.icon} text-teal-600 text-sm`} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-800 mb-0.5">{item.title}</p>
                    <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Timeline mockup */}
          <div className="space-y-3">
            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-5">
              <div className="flex items-center justify-between mb-4">
                <p className="text-xs font-semibold text-gray-700">Sara Al-Farsi — Bali Trip Journey</p>
                <span className="text-[10px] bg-teal-50 text-teal-600 px-2 py-0.5 rounded-full">WhatsApp Timeline</span>
              </div>

              {/* Timeline */}
              <div className="relative">
                <div className="absolute left-4 top-0 bottom-0 w-[2px] bg-gray-200" />
                <div className="space-y-4">
                  {timeline.map((step) => (
                    <div key={step.label} className="relative flex items-start gap-4 pl-10">
                      <div className={`absolute left-[10px] top-1 w-5 h-5 rounded-full border-2 flex items-center justify-center z-10
                        ${step.status === 'done' ? 'bg-teal-500 border-teal-500' : step.status === 'active' ? 'bg-emerald-400 border-emerald-400 animate-pulse' : 'bg-white border-gray-300'}`}
                      >
                        {step.status === 'done' && <i className="ri-check-line text-white text-[10px]" />}
                        {step.status === 'active' && <i className="ri-radio-button-line text-white text-[10px]" />}
                      </div>
                      <div className="flex-1 bg-white rounded-xl border border-gray-100 p-3">
                        <div className="flex items-center justify-between mb-1">
                          <p className="text-xs font-semibold text-gray-800">{step.label}</p>
                          <span className="text-[10px] text-gray-400">{step.time}</span>
                        </div>
                        <div className="bg-[#ECE5DD] rounded-lg px-3 py-1.5">
                          <p className="text-[11px] text-gray-700 italic">{step.msg}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* CRM score */}
            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl border border-teal-100 p-4 flex items-center gap-4">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center shrink-0">
                <i className="ri-user-heart-line text-white text-lg" />
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-800">Sara is a repeat customer candidate</p>
                <p className="text-[11px] text-gray-500 mt-0.5">4.8★ satisfaction • 2 trips booked • &ldquo;Loves beach destinations&rdquo;</p>
              </div>
              <div className="ml-auto">
                <button type="button" className="text-[10px] font-medium bg-teal-600 text-white px-3 py-1.5 rounded-lg cursor-pointer whitespace-nowrap hover:bg-teal-700 transition-colors">
                  Send Offer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
